import React, { useState, useEffect } from 'react';
import Header from '../../dashboard/header';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useAuth from '../../dashboard/useAuth';
import { BsPeople } from 'react-icons/bs';
import ReactQuill from 'react-quill';  // Quill editor
import 'react-quill/dist/quill.snow.css';  // Quill styles
import { Navigate } from 'react-router-dom';
import axios from 'axios';

const Ajouter_groupe = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('IDDDD');
    const navigate = useNavigate();
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [userData, setUserData] = useState([]);

    const [formData, setFormData] = useState({
        nom: '',
        description: '',
        type_groupe: 'Cohorte',
    });

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Ajouter Groupe";
        }
    }, [user_id]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = {
            nom: formData.nom,
            description: formData.description,
            type_groupe: formData.type_groupe,
        };

        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/ajouter-groupe/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
                showAlert("Erreur lors de la création du groupe.", "danger");
            } else {
                const responseData = await response.json();
                console.log('Succès:', responseData);
                showAlert("Groupe créé avec succès !", "success");
                navigate(`/Liste-groupe`);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert("Erreur réseau. Veuillez réessayer.", "danger");
        }
    };

    const handleCancel = () => {
        setFormData({
            nom: '',
            description: '',
            type_groupe: '',
        });
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline'],
            ['link', 'image'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['clean'],
            [{ 'align': [] }],
        ],
    };

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/recup-info-profil/${user_id}/`);
                if (!response.ok) throw new Error('Erreur réseau');
                const data = await response.json();
                setUserData(data);
            } catch (error) {
                console.error('Erreur lors de la récupération des données utilisateur:', error);
            }
        };

        fetchUserData();
    }, [user_id]);

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Groupes")) {
        return null;
    }

    if (userData.coach_groupe) {
        return <Navigate to="/" replace />;
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><BsPeople size={25} className='mr-2' />Nouveau Groupe</h2>
                            <small>Administration des groupes d'utilisateur.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-groupe`}>Groupes</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Ajouter-groupe`}>Nouveau Groupe</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="container-fluid"> {/* Ensure full container for responsiveness */}
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-8 mx-auto mt-5 mb-3"> {/* Use breakpoints for responsive form */}
                                <div className="ibox-content">
                                    <div className="hpanel">
                                        <div className="panel-body">
                                            {alert.message && (
                                                <div className={`alert alert-${alert.type}`}>
                                                    {alert.message}
                                                </div>
                                            )}
                                            <form className="m-t" role="form" onSubmit={handleSubmit} encType="multipart/form-data">
                                                <div className="form-group">
                                                    <label>Nom*</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        required
                                                        name="nom"
                                                        value={formData.nom}
                                                        onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Description</label>
                                                    {/* Use ReactQuill for the description field */}
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        required
                                                        name="description"
                                                        value={formData.description || ''}
                                                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Type du groupe*</label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="type_groupe"
                                                        value={formData.type_groupe}
                                                        onChange={(e) => setFormData({ ...formData, type_groupe: e.target.value })}
                                                    >
                                                        <option value="Cohorte">Cohorte</option>
                                                        <option value="Groupe système">Groupe système</option>
                                                    </select>
                                                </div>

                                                <div className="text-center mt-5">
                                                    <a type="reset" href={`/Liste-groupe`} className="btn btn-default mr-2">Annuler</a>
                                                    <button type="button" className="btn btn-default mr-2" onClick={handleCancel}>Effacer</button>
                                                    <button type="submit" className="btn btn-success">Enregistrer</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Ajouter_groupe;
